import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { LoadingButton } from '@mui/lab'
import { useInviteContactToPortalMutation } from 'services/customers'
import { dispatchSnackbar } from 'utils/helpers'

const CustomerPortalInviteCell = ({ params, customerData, setShowEmailAlert }) => {
  const dispatch = useDispatch()

  const [inviteContactToPortal, { isLoading: isLoadingInviteContactToPortal }] = useInviteContactToPortalMutation()

  const { row } = params || {}
  const { gsUserId, email } = row || {}
  return (
    <LoadingButton
      loading={isLoadingInviteContactToPortal}
      variant="outlined"
      disabled={!!gsUserId || isLoadingInviteContactToPortal}
      onClick={async () => {
        try {
          if (!email) {
            setShowEmailAlert(true)
            return
          }
          const { error: inviteContactError } = await inviteContactToPortal({
            customerId: customerData.id,
            contactId: row.id,
            gsPortalUserRequestBody: {
              firstName: row.firstName || row.firstNameLegal,
              lastName: row.lastName || row.lastNameLegal,
              email,
            },
          })
          if (inviteContactError) throw new Error(inviteContactError?.data?.error)
          dispatchSnackbar(dispatch, 'success', `Invite sent to ${email}`)
        } catch (error: any) {
          const message = error?.data?.error || error?.message || 'An error occurred'
          dispatchSnackbar(dispatch, 'error', message)
        }
      }}
    >
      Invite
    </LoadingButton>
  )
}

CustomerPortalInviteCell.propTypes = {
  params: PropTypes.object.isRequired,
  customerData: PropTypes.object.isRequired,
  setShowEmailAlert: PropTypes.func.isRequired,
}

export default CustomerPortalInviteCell
